"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdContestoUtenteService = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
class TpdContestoUtenteService {
    constructor() {
        this.commonNetworkService = new nodejs_library_1.CommonNetworkService();
        this.prefixMeV1 = "/api/priv/contesto-utente/v1/me";
    }
    cliente() {
        const url = this.prefixMeV1 + "/account";
        return this.commonNetworkService.get(url);
    }
}
exports.TpdContestoUtenteService = TpdContestoUtenteService;
